export type PullRequestUserActionCategory = 'stack_navigator' | 'merge_box'

export type PullRequestUserActionStack = {
  id: number
  number: number
  created_at: string | null | undefined
}

type StackNavigatorOpenPayload = {
  category: 'stack_navigator'
  action: 'open'
  data: {
    stack: PullRequestUserActionStack
    source: 'sidebar' | 'pr_header' | 'keyboard_shortcut'
  }
}

type StackNavigatorSwitchBranchPayload = {
  category: 'stack_navigator'
  action: 'switch_branch'
  data: {
    stack: PullRequestUserActionStack
    target_pull_request_id: number
    target_position_in_stack: number
  }
}

type StackNavigatorAddToStackPayload = {
  category: 'stack_navigator'
  action: 'add_to_stack_click'
  data: {
    stack: PullRequestUserActionStack
    stack_size_before: number
  }
}

type StackNavigatorUnstackPayload = {
  category: 'stack_navigator'
  action: 'unstack_click'
  data: {
    stack: PullRequestUserActionStack
    stack_size: number
  }
}

type MergeBoxSwitchBranchPayload = {
  category: 'merge_box'
  action: 'stack_switch_branch'
  data: {
    stack: PullRequestUserActionStack
    target_pull_request_id: number
    target_position_in_stack: number
  }
}

type MergeBoxRebasePayload = {
  category: 'merge_box'
  action: 'stack_rebase_click'
  data: {
    stack: PullRequestUserActionStack
    stack_size: number
    position_in_stack: number
  }
}

type MergeBoxMergePayload = {
  category: 'merge_box'
  action: 'stack_merge_click'
  data: {
    stack: PullRequestUserActionStack
    merge_method: string
    stack_size: number
    position_in_stack: number
    uses_merge_queue: boolean
  }
}

export type PullRequestUserActionPayload =
  | StackNavigatorOpenPayload
  | StackNavigatorSwitchBranchPayload
  | StackNavigatorAddToStackPayload
  | StackNavigatorUnstackPayload
  | MergeBoxSwitchBranchPayload
  | MergeBoxRebasePayload
  | MergeBoxMergePayload

export function buildPullRequestUserActionContext(payload: PullRequestUserActionPayload) {
  return {
    category: payload.category,
    action: payload.action,
    data: JSON.stringify(payload.data),
  }
}
